'use client'

import { useLayoutEffect } from 'react'

/**
 * Se activa cuando el navegador cambia de entrada del historial (atrás/adelante):
 * en ese caso Next restaura la posición guardada y no hay que pisarla.
 * Se registra al evaluar el módulo (antes de cualquier montaje de la ficha) y se
 * consume una sola vez por montaje.
 */
let arrivedByHistory = false
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    arrivedByHistory = true
  })
}

/**
 * Lleva la PDP al inicio al entrar en ella con un enlace.
 *
 * `<Link>` solo hace scroll al top si el primer elemento de la página queda
 * fuera del viewport, y no cuenta el header sticky como parte de lo que tapa:
 * con el listado de origen poco desplazado, la ficha abría con los breadcrumbs
 * ocultos bajo el header. Mismo problema (y misma solución) que
 * `AlphaEntryLink`, pero aquí aplicado en destino para cubrir cualquier origen.
 *
 * Headless; no actúa con un ancla (`#hash`) ni al volver con atrás/adelante.
 */
export function PerformanceScrollToTop() {
  useLayoutEffect(() => {
    const byHistory = arrivedByHistory
    arrivedByHistory = false
    if (byHistory || window.location.hash) return
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [])

  return null
}
